import { z } from 'zod';
import { Gender } from './registerSchema';

export const ManagerGenderEnum = z.nativeEnum(Gender);
export type ManagerGender = z.infer<typeof ManagerGenderEnum>;

const newUserSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'El nombre es requerido' })
    .max(100, { message: 'El nombre es demasiado largo' }),
  gender: ManagerGenderEnum,
  birthdate: z.string().optional(),
});

export const playerSlotSchema = z
  .object({
    email: z.string().email({ message: 'Ingresá un email válido' }),
    newUser: newUserSchema.optional(),
    categoryId: z.number().int().positive().optional(),
  })
  .refine((slot) => slot.newUser !== undefined, {
    message: 'Faltan datos para crear al jugador',
    path: ['newUser'],
  })
  .refine((slot) => slot.categoryId !== undefined, {
    message: 'Elegí una categoría para el jugador',
    path: ['categoryId'],
  });

export type PlayerSlotInput = z.infer<typeof playerSlotSchema>;

export const managerRegisterPairSchema = z.object({
  players: z.array(playerSlotSchema).min(1),
});

export type ManagerRegisterPairFormInput = z.infer<
  typeof managerRegisterPairSchema
>;

// Cuando el torneo tiene restricción de edad, exigimos birthdate para las cuentas nuevas.
// Para el caso "sin restricción" la fecha es opcional (queda con default en el populator del backend).
export function validateBirthdateForAgeRestricted(
  slot: PlayerSlotInput,
  ageRestricted: boolean,
): string | null {
  if (!ageRestricted) return null;
  if (!slot.newUser?.birthdate) {
    return 'El torneo tiene restricción de edad; cargá la fecha de nacimiento';
  }
  return null;
}
